import { css } from 'styled-components'
// import { minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'


const eventAddr = css`
  font-weight: bold;
`
const eventDate = css`
  color: ${variables.BASE_TXC};
`
const subEvent = css`
  color: ${variables.BASE_TXC};
  font-weight: bold;
`
const zerochalleTitle = css`
  margin-top: 20px!important;
`
const zerochalleMargin = css`
  margin-top: 5px;
`
const zeroCarbonTitle = css`
  margin-top: 30px;
`
const zeroCarbonName = css`
  margin-top: 10px;
`

export const no159Style = {
  eventAddr,
  eventDate,
  subEvent,
  zerochalleTitle,
  zerochalleMargin,
  zeroCarbonTitle,
  zeroCarbonName
}
